import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import SponsorStickyCTA from "@/components/SponsorStickyCTA";
import ShareThisPage from "@/components/ShareThisPage";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Schedule from "@/pages/Schedule";
import Standings from "@/pages/Standings";
import Players from "@/pages/Players";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Sponsorships from "@/pages/Sponsorships";
import Partnerships from "@/pages/Partnerships";
import Academies from "@/pages/Academies";
import Media from "@/pages/Media";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";
import { getAdminToken } from "@/lib/adminAuth";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function RequireAdmin({ children }) {
  if (!getAdminToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App grain min-h-screen bg-pshl-bg text-white">
        <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pt-16 md:pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/teams/:slug" element={<TeamDetail />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/standings" element={<Standings />} />
            <Route path="/players" element={<Players />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/sponsorships" element={<Sponsorships />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/academies" element={<Academies />} />
            <Route path="/media" element={<Media />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/leads" element={<RequireAdmin><AdminLeads /></RequireAdmin>} />
            <Route path="/admin" element={<Navigate to="/admin/leads" replace />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <ShareThisPage />
        <SponsorStickyCTA />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#041E42",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
